export default __webpack_public_path__ + "media/tiket.477f6c75.png";